<template>
  <Modal
    title="Force Accept Quote"
    :saving="saving"
    @hide-modal="$emit('hide-modal')"
    @submit="handleApprove"
  >
    <WarningMessage
      >Accepting this quote will require a new work completed
      signature.</WarningMessage
    >
    <form @submit.prevent="handleApprove">
      <text-area v-model="approvalNote" label="Accept Reason"></text-area>
    </form>
  </Modal>
</template>

<script>
import WarningMessage from "serviceshift-ui/components/General/WarningMessage.vue";
import { mapActions } from "vuex";
import { EventBus } from "@/lib/event_bus.js";

import Modal from "@/components/Modal.vue";
import TextArea from "@/components/TextArea.vue";

export default {
  components: {
    Modal,
    TextArea,
    WarningMessage
  },
  props: {
    quote: {
      type: Object,
      default: () => ({})
    }
  },
  emits: ["hide-modal"],
  data() {
    return {
      approvalNote: "",
      saving: false
    };
  },
  methods: {
    ...mapActions(["approveQuote", "setCurrentQuote", "setCurrentInvoice"]),
    handleApprove() {
      if (this.approvalNote) {
        this.saving = true;
        this.approveQuote({
          url: this.quote.links.quote_force_accept,
          note: this.approvalNote
        })
          .then(() => {
            this.saving = false;
            EventBus.$emit("refresh-quote-datatable");
            this.$emit("hide-modal");
            this.setCurrentQuote(null);
            this.setCurrentInvoice(null);
          })
          .catch(() => (this.saving = false));
      }
    }
  }
};
</script>
